import { CanActivateChildFn } from '@angular/router';
import { inject } from '@angular/core';
import { StateService } from '../other/state';

export function roleGuard(allowedRoles: string[]): CanActivateChildFn {
  return (_childRoute, _state) => {
    const stateService = inject(StateService);
    const userRole = stateService.userRole();
    return allowedRoles.includes(userRole);
  };
}
